//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    icon: {
      type: String,
      default: 'clipboard-edit-outline',
    },
  },
}
